import { BaseAction } from "../../../core/actions/BaseAction"
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ITicketOptionResponse } from "../../../Orchestrator/Types/Interface/ITicketOption";
import ticketManager from "../../../Lib/Utils/TicketOptionManager";

class GetTicketOptionsAction extends BaseAction<ITicketOptionResponse, void> {
  protected override async run(): Promise<ITicketOptionResponse | null> {
    let ticketOptions: ITicketOptionResponse | null = null;

    try {
      // This condition is added to avoid multiple API calls for the same data
      if (this.result === null) {
        // Use TicketManager to avoid duplicate API calls
        await ticketManager.fetchTicketOptions();
        const metaTicketOption = ticketManager.getAllOptions();
        if (Array.isArray(metaTicketOption)) {
          ticketOptions = metaTicketOption;
          updateRecoilState("ticketOptionsAtom", ticketOptions)
        } else {
          console.warn("Failed to load ticket options.");
        }
      }
    } catch (error: any) {
      console.error("Error fetching data:", error);
    } finally {
      return ticketOptions;
    }
  }
}

export const getTicketOptionsAction = new GetTicketOptionsAction();
